export default __webpack_public_path__ + "static/media/ITALogoLight@3x.15fa7671.png";